(() => {
  const defineCE = (name, ctor, options) => {
    if (!window.customElements.get(name)) {
      window.customElements.define(name, ctor, options);
    }
  };

  // node_modules/ftdomdelegate/main.js
  function Delegate(root) {
    this.listenerMap = [{}, {}];
    if (root) {
      this.root(root);
    }
    this.handle = Delegate.prototype.handle.bind(this);
    this._removedListeners = [];
  }
  Delegate.prototype.root = function (root) {
    const listenerMap = this.listenerMap;
    let eventType;
    if (this.rootElement) {
      for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, true);
        }
      }
      for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, false);
        }
      }
    }
    if (!root || !root.addEventListener) {
      if (this.rootElement) {
        delete this.rootElement;
      }
      return this;
    }
    this.rootElement = root;
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, false);
      }
    }
    return this;
  };
  Delegate.prototype.captureForType = function (eventType) {
    return (
      ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
        eventType
      ) !== -1
    );
  };
  Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
    let root;
    let listenerMap;
    let matcher;
    let matcherParam;
    if (!eventType) {
      throw new TypeError("Invalid event type: " + eventType);
    }
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      useCapture = this.captureForType(eventType);
    }
    if (typeof handler !== "function") {
      throw new TypeError("Handler must be a type of Function");
    }
    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!listenerMap[eventType]) {
      if (root) {
        root.addEventListener(eventType, this.handle, useCapture);
      }
      listenerMap[eventType] = [];
    }
    if (!selector) {
      matcherParam = null;
      matcher = matchesRoot.bind(this);
    } else if (/^[a-z]+$/i.test(selector)) {
      matcherParam = selector;
      matcher = matchesTag;
    } else if (/^#[a-z0-9\\-_]+$/i.test(selector)) {
      matcherParam = selector.slice(1);
      matcher = matchesId;
    } else {
      matcherParam = selector;
      matcher = Element.prototype.matches;
    }
    listenerMap[eventType].push({
      selector,
      handler,
      matcher,
      matcherParam,
    });
    return this;
  };
  Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
    let i;
    let listener;
    let listenerMap;
    let listenerList;
    let singleEventType;
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      this.off(eventType, selector, handler, true);
      this.off(eventType, selector, handler, false);
      return this;
    }
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!eventType) {
      for (singleEventType in listenerMap) {
        if (listenerMap.hasOwnProperty(singleEventType)) {
          this.off(singleEventType, selector, handler);
        }
      }
      return this;
    }
    listenerList = listenerMap[eventType];
    if (!listenerList || !listenerList.length) {
      return this;
    }
    for (i = listenerList.length - 1; i >= 0; i--) {
      listener = listenerList[i];
      if (
        (!selector || selector === listener.selector) &&
        (!handler || handler === listener.handler)
      ) {
        this._removedListeners.push(listener);
        listenerList.splice(i, 1);
      }
    }
    if (!listenerList.length) {
      delete listenerMap[eventType];
      if (this.rootElement) {
        this.rootElement.removeEventListener(eventType, this.handle, useCapture);
      }
    }
    return this;
  };
  Delegate.prototype.handle = function (event) {
    let i;
    let l;
    const type = event.type;
    let root;
    let phase;
    let listener;
    let returned;
    let listenerList = [];
    let target;
    const eventIgnore = "ftLabsDelegateIgnore";
    if (event[eventIgnore] === true) {
      return;
    }
    target = event.target;
    if (target.nodeType === 3) {
      target = target.parentNode;
    }
    if (target.correspondingUseElement) {
      target = target.correspondingUseElement;
    }
    root = this.rootElement;
    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
    switch (phase) {
      case 1:
        listenerList = this.listenerMap[1][type];
        break;
      case 2:
        if (this.listenerMap[0] && this.listenerMap[0][type]) {
          listenerList = listenerList.concat(this.listenerMap[0][type]);
        }
        if (this.listenerMap[1] && this.listenerMap[1][type]) {
          listenerList = listenerList.concat(this.listenerMap[1][type]);
        }
        break;
      case 3:
        listenerList = this.listenerMap[0][type];
        break;
    }
    let toFire = [];
    l = listenerList.length;
    while (target && l) {
      for (i = 0; i < l; i++) {
        listener = listenerList[i];
        if (!listener) {
          break;
        }
        if (
          target.tagName &&
          ["button", "input", "select", "textarea"].indexOf(
            target.tagName.toLowerCase()
          ) > -1 &&
          target.hasAttribute("disabled")
        ) {
          toFire = [];
        } else if (
          listener.matcher.call(target, listener.matcherParam, target)
        ) {
          toFire.push([event, target, listener]);
        }
      }
      if (target === root) {
        break;
      }
      l = listenerList.length;
      target = target.parentElement || target.parentNode;
      if (target instanceof HTMLDocument) {
        break;
      }
    }
    let ret;
    for (i = 0; i < toFire.length; i++) {
      if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
        continue;
      }
      returned = this.fire.apply(this, toFire[i]);
      if (returned === false) {
        toFire[i][0][eventIgnore] = true;
        toFire[i][0].preventDefault();
        ret = false;
        break;
      }
    }
    return ret;
  };
  Delegate.prototype.fire = function (event, target, listener) {
    return listener.handler.call(target, event, target);
  };
  function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
  }
  function matchesRoot(selector, element) {
    if (this.rootElement === window) {
      return (
        element === document ||
        element === document.documentElement ||
        element === window
      );
    }
    return this.rootElement === element;
  }
  function matchesId(id, element) {
    return id === element.id;
  }
  Delegate.prototype.destroy = function () {
    this.off();
    this.root();
  };
  var main_default = Delegate;

  // js/helper/event.js
  function triggerEvent(element, name, data = {}) {
    element.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        detail: data,
      })
    );
  }
  function triggerNonBubblingEvent(element, name, data = {}) {
    element.dispatchEvent(
      new CustomEvent(name, {
        bubbles: false,
        detail: data,
      })
    );
  }

  // js/custom-element/custom-html-element.js
  var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super();
      this._hasSectionReloaded = false;
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) => {
          const parentSection = this.closest(".shopify-section");
          if (event.target === parentSection && event.detail.load) {
            this._hasSectionReloaded = true;
          }
        });
      }
    }
    get rootDelegate() {
      return (this._rootDelegate =
        this._rootDelegate || new main_default(document.documentElement));
    }
    get delegate() {
      return (this._delegate = this._delegate || new main_default(this));
    }
    showLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:start");
    }
    hideLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:end");
    }
    disconnectedCallback() {
      this.delegate.destroy();
      this.rootDelegate.destroy();
      delete this._delegate;
      delete this._rootDelegate;
    }
  };

  // Focus trap (minimally re-used as-is from theme.js bundle)
  // Note: this block is intentionally kept verbatim-ish to avoid subtle focus regressions.
  var candidateSelectors = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])',
    "details>summary:first-of-type",
    "details",
  ];
  var candidateSelector = candidateSelectors.join(",");
  var matches =
    typeof Element === "undefined"
      ? function () {}
      : Element.prototype.matches ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
  var getCandidates = function getCandidates2(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(
      el.querySelectorAll(candidateSelector)
    );
    if (includeContainer && matches.call(el, candidateSelector)) {
      candidates.unshift(el);
    }
    candidates = candidates.filter(filter);
    return candidates;
  };
  var isContentEditable = function isContentEditable2(node) {
    return node.contentEditable === "true";
  };
  var getTabindex = function getTabindex2(node) {
    var tabindexAttr = parseInt(node.getAttribute("tabindex"), 10);
    if (!isNaN(tabindexAttr)) {
      return tabindexAttr;
    }
    if (isContentEditable(node)) {
      return 0;
    }
    if (
      (node.nodeName === "AUDIO" ||
        node.nodeName === "VIDEO" ||
        node.nodeName === "DETAILS") &&
      node.getAttribute("tabindex") === null
    ) {
      return 0;
    }
    return node.tabIndex;
  };
  var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
    return a.tabIndex === b.tabIndex
      ? a.documentOrder - b.documentOrder
      : a.tabIndex - b.tabIndex;
  };
  var isInput = function isInput2(node) {
    return node.tagName === "INPUT";
  };
  var isHiddenInput = function isHiddenInput2(node) {
    return isInput(node) && node.type === "hidden";
  };
  var isDetailsWithSummary = function isDetailsWithSummary2(node) {
    var r =
      node.tagName === "DETAILS" &&
      Array.prototype.slice.apply(node.children).some(function (child) {
        return child.tagName === "SUMMARY";
      });
    return r;
  };
  var getCheckedRadio = function getCheckedRadio2(nodes, form) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].checked && nodes[i].form === form) {
        return nodes[i];
      }
    }
  };
  var isTabbableRadio = function isTabbableRadio2(node) {
    if (!node.name) {
      return true;
    }
    var radioScope = node.form || node.ownerDocument;
    var queryRadios = function queryRadios2(name) {
      return radioScope.querySelectorAll(
        'input[type="radio"][name="' + name + '"]'
      );
    };
    var radioSet;
    if (
      typeof window !== "undefined" &&
      typeof window.CSS !== "undefined" &&
      typeof window.CSS.escape === "function"
    ) {
      radioSet = queryRadios(window.CSS.escape(node.name));
    } else {
      try {
        radioSet = queryRadios(node.name);
      } catch (err) {
        console.error(
          "Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s",
          err.message
        );
        return false;
      }
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
  };
  var isRadio = function isRadio2(node) {
    return isInput(node) && node.type === "radio";
  };
  var isNonTabbableRadio = function isNonTabbableRadio2(node) {
    return isRadio(node) && !isTabbableRadio(node);
  };
  var isHidden = function isHidden2(node, displayCheck) {
    if (getComputedStyle(node).visibility === "hidden") {
      return true;
    }
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
      return true;
    }
    if (!displayCheck || displayCheck === "full") {
      while (node) {
        if (getComputedStyle(node).display === "none") {
          return true;
        }
        node = node.parentElement;
      }
    } else if (displayCheck === "non-zero-area") {
      var _node$getBoundingClie = node.getBoundingClientRect(),
        width = _node$getBoundingClie.width,
        height = _node$getBoundingClie.height;
      return width === 0 && height === 0;
    }
    return false;
  };
  var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
    if (
      isInput(node) ||
      node.tagName === "SELECT" ||
      node.tagName === "TEXTAREA" ||
      node.tagName === "BUTTON"
    ) {
      var parentNode = node.parentElement;
      while (parentNode) {
        if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
          for (var i = 0; i < parentNode.children.length; i++) {
            var child = parentNode.children.item(i);
            if (child.tagName === "LEGEND") {
              if (child.contains(node)) {
                return false;
              }
              return true;
            }
          }
          return true;
        }
        parentNode = parentNode.parentElement;
      }
    }
    return false;
  };
  var isNodeMatchingSelectorFocusable =
    function isNodeMatchingSelectorFocusable2(options, node) {
      if (
        node.disabled ||
        isHiddenInput(node) ||
        isHidden(node, options.displayCheck) ||
        isDetailsWithSummary(node) ||
        isDisabledFromFieldset(node)
      ) {
        return false;
      }
      return true;
    };
  var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(
    options,
    node
  ) {
    if (
      !isNodeMatchingSelectorFocusable(options, node) ||
      isNonTabbableRadio(node) ||
      getTabindex(node) < 0
    ) {
      return false;
    }
    return true;
  };
  var tabbable = function tabbable2(el, options) {
    options = options || {};
    var regularTabbables = [];
    var orderedTabbables = [];
    var candidates = getCandidates(
      el,
      options.includeContainer,
      isNodeMatchingSelectorTabbable.bind(null, options)
    );
    candidates.forEach(function (candidate, i) {
      var candidateTabindex = getTabindex(candidate);
      if (candidateTabindex === 0) {
        regularTabbables.push(candidate);
      } else {
        orderedTabbables.push({
          documentOrder: i,
          tabIndex: candidateTabindex,
          node: candidate,
        });
      }
    });
    var tabbableNodes = orderedTabbables
      .sort(sortOrderedTabbables)
      .map(function (a) {
        return a.node;
      })
      .concat(regularTabbables);
    return tabbableNodes;
  };
  var focusableCandidateSelector = candidateSelectors.concat("iframe").join(",");
  var isFocusable = function isFocusable2(node, options) {
    options = options || {};
    if (!node) {
      throw new Error("No node provided");
    }
    if (matches.call(node, focusableCandidateSelector) === false) {
      return false;
    }
    return isNodeMatchingSelectorFocusable(options, node);
  };

  // Minimal bits of focus-trap (kept as-is from bundle)
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(
          target,
          Object.getOwnPropertyDescriptors(source)
        );
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(
            target,
            key,
            Object.getOwnPropertyDescriptor(source, key)
          );
        });
      }
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true,
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var activeFocusTraps = (function () {
    var trapQueue = [];
    return {
      activateTrap: function activateTrap(trap) {
        if (trapQueue.length > 0) {
          var activeTrap = trapQueue[trapQueue.length - 1];
          if (activeTrap !== trap) {
            activeTrap.pause();
          }
        }
        var trapIndex = trapQueue.indexOf(trap);
        if (trapIndex === -1) {
          trapQueue.push(trap);
        } else {
          trapQueue.splice(trapIndex, 1);
          trapQueue.push(trap);
        }
      },
      deactivateTrap: function deactivateTrap(trap) {
        var trapIndex = trapQueue.indexOf(trap);
        if (trapIndex !== -1) {
          trapQueue.splice(trapIndex, 1);
        }
        if (trapQueue.length > 0) {
          trapQueue[trapQueue.length - 1].unpause();
        }
      },
    };
  })();
  var isSelectableInput = function isSelectableInput2(node) {
    return (
      node.tagName &&
      node.tagName.toLowerCase() === "input" &&
      typeof node.select === "function"
    );
  };
  var delay = function delay2(fn) {
    return setTimeout(fn, 0);
  };
  var findIndex = function findIndex2(arr, fn) {
    var idx = -1;
    arr.every(function (value, i) {
      if (fn(value)) {
        idx = i;
        return false;
      }
      return true;
    });
    return idx;
  };
  var valueOrHandler = function valueOrHandler2(value) {
    for (
      var _len = arguments.length,
        params = new Array(_len > 1 ? _len - 1 : 0),
        _key = 1;
      _key < _len;
      _key++
    ) {
      params[_key - 1] = arguments[_key];
    }
    return typeof value === "function" ? value.apply(void 0, params) : value;
  };
  var getActualTarget = function getActualTarget2(event) {
    return event.target.shadowRoot && typeof event.composedPath === "function"
      ? event.composedPath()[0]
      : event.target;
  };
  var createFocusTrap = function createFocusTrap2(elements, userOptions) {
    var doc =
      (userOptions === null || userOptions === void 0
        ? void 0
        : userOptions.document) || document;
    var config = _objectSpread2(
      {
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
      },
      userOptions
    );
    var state = {
      containers: [],
      tabbableGroups: [],
      nodeFocusedBeforeActivation: null,
      mostRecentlyFocusedNode: null,
      active: false,
      paused: false,
      delayInitialFocusTimer: void 0,
    };
    var trap;
    var getOption = function getOption2(
      configOverrideOptions,
      optionName,
      configOptionName
    ) {
      return configOverrideOptions &&
        configOverrideOptions[optionName] !== void 0
        ? configOverrideOptions[optionName]
        : config[configOptionName || optionName];
    };
    var containersContain = function containersContain2(element) {
      return !!(
        element &&
        state.containers.some(function (container) {
          return container.contains(element);
        })
      );
    };
    var getNodeForOption = function getNodeForOption2(optionName) {
      var optionValue = config[optionName];
      if (typeof optionValue === "function") {
        for (
          var _len2 = arguments.length,
            params = new Array(_len2 > 1 ? _len2 - 1 : 0),
            _key2 = 1;
          _key2 < _len2;
          _key2++
        ) {
          params[_key2 - 1] = arguments[_key2];
        }
        optionValue = optionValue.apply(void 0, params);
      }
      if (!optionValue) {
        if (optionValue === void 0 || optionValue === false) {
          return optionValue;
        }
        throw new Error(
          "`".concat(
            optionName,
            "` was specified but was not a node, or did not return a node"
          )
        );
      }
      var node = optionValue;
      if (typeof optionValue === "string") {
        node = doc.querySelector(optionValue);
        if (!node) {
          throw new Error(
            "`".concat(optionName, "` as selector refers to no known node")
          );
        }
      }
      return node;
    };
    var getInitialFocusNode = function getInitialFocusNode2() {
      var node = getNodeForOption("initialFocus");
      if (node === false) {
        return false;
      }
      if (node === void 0) {
        if (containersContain(doc.activeElement)) {
          node = doc.activeElement;
        } else {
          var firstTabbableGroup = state.tabbableGroups[0];
          var firstTabbableNode =
            firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
          node = firstTabbableNode || getNodeForOption("fallbackFocus");
        }
      }
      if (!node) {
        throw new Error(
          "Your focus-trap needs to have at least one focusable element"
        );
      }
      return node;
    };
    var updateTabbableNodes = function updateTabbableNodes2() {
      state.tabbableGroups = state.containers
        .map(function (container) {
          var tabbableNodes = tabbable(container);
          if (tabbableNodes.length > 0) {
            return {
              container,
              firstTabbableNode: tabbableNodes[0],
              lastTabbableNode: tabbableNodes[tabbableNodes.length - 1],
            };
          }
          return void 0;
        })
        .filter(function (group) {
          return !!group;
        });
      if (
        state.tabbableGroups.length <= 0 &&
        !getNodeForOption("fallbackFocus")
      ) {
        throw new Error(
          "Your focus-trap must have at least one container with at least one tabbable node in it at all times"
        );
      }
    };
    var tryFocus = function tryFocus2(node) {
      if (node === false) {
        return;
      }
      if (node === doc.activeElement) {
        return;
      }
      if (!node || !node.focus) {
        tryFocus2(getInitialFocusNode());
        return;
      }
      node.focus({
        preventScroll: !!config.preventScroll,
      });
      state.mostRecentlyFocusedNode = node;
      if (isSelectableInput(node)) {
        node.select();
      }
    };
    var getReturnFocusNode = function getReturnFocusNode2(
      previousActiveElement
    ) {
      var node = getNodeForOption("setReturnFocus", previousActiveElement);
      return node ? node : node === false ? false : previousActiveElement;
    };
    var checkPointerDown = function checkPointerDown2(e) {
      var target = getActualTarget(e);
      if (containersContain(target)) {
        return;
      }
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        trap.deactivate({
          returnFocus: config.returnFocusOnDeactivate && !isFocusable(target),
        });
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn2(e) {
      var target = getActualTarget(e);
      var targetContained = containersContain(target);
      if (targetContained || target instanceof Document) {
        if (targetContained) {
          state.mostRecentlyFocusedNode = target;
        }
      } else {
        e.stopImmediatePropagation();
        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
      }
    };
    var checkTab = function checkTab2(e) {
      var target = getActualTarget(e);
      updateTabbableNodes();
      var destinationNode = null;
      if (state.tabbableGroups.length > 0) {
        var containerIndex = findIndex(state.tabbableGroups, function (_ref) {
          var container = _ref.container;
          return container.contains(target);
        });
        if (containerIndex < 0) {
          if (e.shiftKey) {
            destinationNode =
              state.tabbableGroups[state.tabbableGroups.length - 1]
                .lastTabbableNode;
          } else {
            destinationNode = state.tabbableGroups[0].firstTabbableNode;
          }
        } else if (e.shiftKey) {
          if (
            target === state.tabbableGroups[containerIndex].firstTabbableNode
          ) {
            destinationNode =
              state.tabbableGroups[containerIndex - 1 >= 0 ? containerIndex - 1 : state.tabbableGroups.length - 1]
                .lastTabbableNode;
          }
        } else if (
          target === state.tabbableGroups[containerIndex].lastTabbableNode
        ) {
          destinationNode =
            state.tabbableGroups[(containerIndex + 1) % state.tabbableGroups.length]
              .firstTabbableNode;
        }
      }
      if (destinationNode) {
        e.preventDefault();
        tryFocus(destinationNode);
      }
    };
    var checkKey = function checkKey2(e) {
      if (e.key === "Tab" || e.keyCode === 9) {
        checkTab(e);
        return;
      }
      if (e.key === "Escape" || e.key === "Esc" || e.keyCode === 27) {
        if (valueOrHandler(config.escapeDeactivates, e) !== false) {
          e.preventDefault();
          trap.deactivate();
        }
      }
    };
    var checkClick = function checkClick2(e) {
      var target = getActualTarget(e);
      if (containersContain(target)) {
        return;
      }
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        trap.deactivate({
          returnFocus: config.returnFocusOnDeactivate && !isFocusable(target),
        });
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
    };
    var addListeners = function addListeners2() {
      if (!state.active) return;
      doc.addEventListener("keydown", checkKey, true);
      doc.addEventListener("focusin", checkFocusIn, true);
      doc.addEventListener("mousedown", checkPointerDown, true);
      doc.addEventListener("touchstart", checkPointerDown, true);
      doc.addEventListener("click", checkClick, true);
    };
    var removeListeners = function removeListeners2() {
      doc.removeEventListener("keydown", checkKey, true);
      doc.removeEventListener("focusin", checkFocusIn, true);
      doc.removeEventListener("mousedown", checkPointerDown, true);
      doc.removeEventListener("touchstart", checkPointerDown, true);
      doc.removeEventListener("click", checkClick, true);
    };
    trap = {
      activate: function activate(activateOptions) {
        if (state.active) return this;
        state.active = true;
        state.paused = false;
        state.nodeFocusedBeforeActivation = doc.activeElement;
        updateTabbableNodes();
        addListeners();
        activeFocusTraps.activateTrap(trap);
        delay(function () {
          tryFocus(getInitialFocusNode());
        });
        return this;
      },
      deactivate: function deactivate(deactivateOptions) {
        if (!state.active) return this;
        removeListeners();
        state.active = false;
        state.paused = false;
        activeFocusTraps.deactivateTrap(trap);
        var returnFocus = getOption(
          deactivateOptions,
          "returnFocus",
          "returnFocusOnDeactivate"
        );
        if (returnFocus) {
          delay(function () {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          });
        }
        return this;
      },
      pause: function pause() {
        if (state.paused || !state.active) return this;
        state.paused = true;
        removeListeners();
        return this;
      },
      unpause: function unpause() {
        if (!state.paused || !state.active) return this;
        state.paused = false;
        updateTabbableNodes();
        addListeners();
        return this;
      },
    };
    trap.updateContainerElements = function updateContainerElements2(
      containerElements
    ) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === "string" ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      return this;
    };
    trap.updateContainerElements(elements);
    return trap;
  };

  // js/helper/section.js
  function filterShopifyEvent(event, domElement, callback) {
    let executeCallback = false;
    if (event.type.includes("shopify:section")) {
      if (
        domElement.hasAttribute("section") &&
        domElement.getAttribute("section") === event.detail.sectionId
      ) {
        executeCallback = true;
      }
    } else if (
      event.type.includes("shopify:block") &&
      event.target === domElement
    ) {
      executeCallback = true;
    }
    if (executeCallback) {
      callback(event);
    }
  }

  // js/custom-element/behavior/openable-element.js
  var OpenableElement = class extends CustomHTMLElement {
    static get observedAttributes() {
      return ["open"];
    }
    constructor() {
      super();
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) =>
          filterShopifyEvent(event, this, () => (this.open = true))
        );
        this.rootDelegate.on("shopify:section:deselect", (event) =>
          filterShopifyEvent(event, this, () => (this.open = false))
        );
      }
      if (this.hasAttribute("append-body")) {
        const existingNode = document.getElementById(this.id);
        this.removeAttribute("append-body");
        if (existingNode && existingNode !== this) {
          existingNode.remove();
          document.body.appendChild(this);
        } else {
          document.body.appendChild(this);
        }
        this._maybeWireOpenableClickDelegates();
      }
    }
    _maybeWireOpenableClickDelegates() {
      if (this._openableClickDelegatesWired || !this.isConnected) {
        return;
      }
      this._openableClickDelegatesWired = true;
      this.delegate.on("click", ".openable__overlay", () => (this.open = false));
      this.delegate.on("click", '[data-action="close"]', (event) => {
        event.stopPropagation();
        this.open = false;
      });
    }
    connectedCallback() {
      this._maybeWireOpenableClickDelegates();
    }
    disconnectedCallback() {
      this._openableClickDelegatesWired = false;
      super.disconnectedCallback();
    }
    get requiresLoading() {
      return this.hasAttribute("href");
    }
    get open() {
      return this.hasAttribute("open");
    }
    set open(value) {
      if (value) {
        (async () => {
          await this._load();
          this.clientWidth;
          this.setAttribute("open", "");
        })();
      } else {
        this.removeAttribute("open");
      }
    }
    get shouldTrapFocus() {
      return true;
    }
    get returnFocusOnDeactivate() {
      return (
        !this.hasAttribute("return-focus") ||
        this.getAttribute("return-focus") === "true"
      );
    }
    get focusTrap() {
      return (this._focusTrap =
        this._focusTrap ||
        createFocusTrap(this, {
          fallbackFocus: this,
          initialFocus: this.hasAttribute("initial-focus-selector")
            ? this.getAttribute("initial-focus-selector")
            : void 0,
          clickOutsideDeactivates: (event) =>
            !(
              event.target.hasAttribute("aria-controls") &&
              event.target.getAttribute("aria-controls") === this.id
            ),
          allowOutsideClick: (event) =>
            event.target.hasAttribute("aria-controls") &&
            event.target.getAttribute("aria-controls") === this.id,
          returnFocusOnDeactivate: this.returnFocusOnDeactivate,
          onDeactivate: () => (this.open = false),
          preventScroll: true,
        }));
    }
    attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case "open":
          if (oldValue === null && newValue === "") {
            if (this.shouldTrapFocus) {
              setTimeout(() => this.focusTrap.activate(), 150);
            }
            triggerEvent(this, "openable-element:open");
          } else if (newValue === null) {
            if (this.shouldTrapFocus) {
              this.focusTrap.deactivate();
            }
            triggerEvent(this, "openable-element:close");
          }
      }
    }
    async _load() {
      if (!this.requiresLoading) {
        return;
      }
      triggerNonBubblingEvent(this, "openable-element:load:start");
      const response = await fetch(this.getAttribute("href"));
      const element = document.createElement("div");
      element.innerHTML = await response.text();
      this.innerHTML = element.querySelector(this.tagName.toLowerCase()).innerHTML;
      this.removeAttribute("href");
      triggerNonBubblingEvent(this, "openable-element:load:end");
    }
  };
  defineCE("openable-element", OpenableElement);

  // js/custom-element/behavior/collapsible-content.js
  var CollapsibleContent = class extends OpenableElement {
    constructor() {
      super();
      this.ignoreNextTransition = this.open;
      this.addEventListener("shopify:block:select", () => (this.open = true));
      this.addEventListener("shopify:block:deselect", () => (this.open = false));
    }
    get animateItems() {
      return this.hasAttribute("animate-items");
    }
    attributeChangedCallback(name) {
      if (this.ignoreNextTransition) {
        return (this.ignoreNextTransition = false);
      }
      switch (name) {
        case "open":
          this.style.overflow = "hidden";
          const keyframes = {
            height: ["0px", `${this.scrollHeight}px`],
            visibility: ["hidden", "visible"],
          };
          if (this.animateItems) {
            keyframes["opacity"] = this.open ? [0, 0] : [0, 1];
          }
          this.animate(keyframes, {
            duration: 500,
            direction: this.open ? "normal" : "reverse",
            easing: "cubic-bezier(0.75, 0, 0.175, 1)",
          }).onfinish = () => {
            this.style.overflow = this.open ? "visible" : "hidden";
          };
          if (this.animateItems && this.open) {
            this.animate(
              {
                opacity: [0, 1],
                transform: ["translateY(10px)", "translateY(0)"],
              },
              {
                duration: 250,
                delay: 250,
                easing: "cubic-bezier(0.75, 0, 0.175, 1)",
              }
            );
          }
          triggerEvent(
            this,
            this.open ? "openable-element:open" : "openable-element:close"
          );
      }
    }
  };
  defineCE("collapsible-content", CollapsibleContent);

  // js/custom-element/ui/scrollable-content.js
  var ScrollableContent = class extends CustomHTMLElement {
    connectedCallback() {
      this._updateScrollState = this._updateScrollState.bind(this);
      this.addEventListener("scroll", this._updateScrollState, { passive: true });
      this._resizeObserver = new ResizeObserver(this._updateScrollState);
      this._resizeObserver.observe(this);
      Array.from(this.children).forEach((child) => this._resizeObserver.observe(child));
      window.addEventListener("resize", this._updateScrollState);
      this._updateScrollState();
    }
    disconnectedCallback() {
      window.removeEventListener("resize", this._updateScrollState);
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
      this.removeEventListener("scroll", this._updateScrollState);
      super.disconnectedCallback();
    }
    _updateScrollState() {
      this.classList.toggle("is-scrollable", this.scrollWidth > this.clientWidth + 1);
    }
  };
  defineCE("scrollable-content", ScrollableContent);

  // js/custom-element/ui/tabs-nav.js
  var TabsNav = class extends CustomHTMLElement {
    connectedCallback() {
      this.delegate.on("click", ".tabs-nav__item", (event, target) => {
        if (!target.hasAttribute("aria-controls")) return;
        event.preventDefault();
        this._activateTab(target);
      });
      if (this.hasAttribute("arrows")) {
        this.delegate.on("click", ".tabs-nav__arrow-item", (event, target) => {
          const scroller = this.querySelector(".tabs-nav__scroller");
          if (!scroller) return;
          const arrowButtons = Array.from(this.querySelectorAll(".tabs-nav__arrow-item"));
          const isPrev = arrowButtons.indexOf(target) === 0;
          const distance = Math.max(120, Math.round(scroller.clientWidth * 0.85));
          const rtl = getComputedStyle(scroller).direction === "rtl";
          const sign = (isPrev ? -1 : 1) * (rtl ? -1 : 1);
          scroller.scrollBy({ left: sign * distance, behavior: "smooth" });
        });
      }
    }
    _activateTab(selectedButton) {
      const controlId = selectedButton.getAttribute("aria-controls");
      if (!controlId) return;
      const panel = document.getElementById(controlId);
      if (!panel) return;
      this.querySelectorAll(".tabs-nav__item").forEach((btn) => {
        if (!btn.hasAttribute("aria-controls")) return;
        btn.setAttribute(
          "aria-expanded",
          btn === selectedButton ? "true" : "false"
        );
      });
      const panelIds = Array.from(this.querySelectorAll(".tabs-nav__item"))
        .map((btn) => btn.getAttribute("aria-controls"))
        .filter(Boolean);
      panelIds.forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.hidden = id !== controlId;
      });
    }
  };
  defineCE("tabs-nav", TabsNav);

  // js/custom-element/behavior/confirm-button.js
  var ConfirmButton = class extends HTMLButtonElement {
    connectedCallback() {
      this.addEventListener("click", (event) => {
        if (
          !window.confirm(
            this.getAttribute("data-message") || "Are you sure you wish to do this?"
          )
        ) {
          event.preventDefault();
        }
      });
    }
  }; 
  defineCE("confirm-button", ConfirmButton, { extends: "button" });

  // js/mixin/loader-button.js
  var LoaderButtonMixin = {
    _prepareButton() {
      this.originalContent = this.innerHTML;
      this._startTransitionPromise = null;
      this.innerHTML = `
      <span class="loader-button__text">${this.innerHTML}</span>
      <span class="loader-button__loader" hidden>
        <div class="spinner">
          <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
            <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
          </svg>
        </div>
      </span>
    `;
      this.textElement = this.firstElementChild;
      this.spinnerElement = this.lastElementChild;
      window.addEventListener("pagehide", () => this.removeAttribute("aria-busy"));
    },
    _startTransition() {
      const textAnimation = this.textElement.animate(
        { opacity: [1, 0], transform: ["translateY(0)", "translateY(-10px)"] },
        { duration: 75, easing: "ease", fill: "forwards" }
      );
      this.spinnerElement.hidden = false;
      const spinnerAnimation = this.spinnerElement.animate(
        { opacity: [0, 1], transform: ["translate(-50%, 0%)", "translate(-50%, -50%)"] },
        { duration: 75, delay: 75, easing: "ease", fill: "forwards" }
      );
      this._startTransitionPromise = Promise.all([
        new Promise((resolve) => (textAnimation.onfinish = () => resolve())),
        new Promise((resolve) => (spinnerAnimation.onfinish = () => resolve())),
      ]);
    },
    async _endTransition() {
      if (!this._startTransitionPromise) return;
      await this._startTransitionPromise;
      this.spinnerElement.animate(
        { opacity: [1, 0], transform: ["translate(-50%, -50%)", "translate(-50%, -100%)"] },
        { duration: 75, delay: 100, easing: "ease", fill: "forwards" }
      ).onfinish = () => (this.spinnerElement.hidden = true);
      this.textElement.animate(
        { opacity: [0, 1], transform: ["translateY(10px)", "translateY(0)"] },
        { duration: 75, delay: 175, easing: "ease", fill: "forwards" }
      );
      this._startTransitionPromise = null;
    },
  };

  // js/custom-element/behavior/loader-button.js
  var LoaderButton = class extends HTMLButtonElement {
    static get observedAttributes() {
      return ["aria-busy"];
    }
    constructor() {
      super();
      this.addEventListener("click", (event) => {
        if (
          this.type === "submit" &&
          this.form &&
          this.form.checkValidity() &&
          !this.form.hasAttribute("is")
        ) {
          if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            event.preventDefault();
            this.setAttribute("aria-busy", "true");
            setTimeout(() => this.form.submit(), 250);
          } else {
            this.setAttribute("aria-busy", "true");
          }
        }
      });
    }
    connectedCallback() {
      this._prepareButton();
    }
    disconnectedCallback() {
      this.innerHTML = this.originalContent;
    }
    attributeChangedCallback(property, oldValue, newValue) {
      if (property === "aria-busy") {
        if (newValue === "true") {
          this._startTransition();
        } else {
          this._endTransition();
        }
      }
    }
  };
  Object.assign(LoaderButton.prototype, LoaderButtonMixin);
  defineCE("loader-button", LoaderButton, { extends: "button" });

  // js/custom-element/behavior/toggle-button.js
  var ToggleButton = class extends HTMLButtonElement {
    static get observedAttributes() {
      return ["aria-expanded", "aria-busy"];
    }
    constructor() {
      super();
      if (this.hasAttribute("loader")) {
        this._prepareButton();
      }
      this.addEventListener("click", this._onButtonClick.bind(this));
      this.rootDelegate = new main_default(document.documentElement);
    }
    _onButtonClick() {
      this.isExpanded = !this.isExpanded;
    }
    connectedCallback() {
      document.addEventListener("openable-element:close", (event) => {
        if (this.controlledElement === event.target) {
          this.isExpanded = false;
          event.stopPropagation();
        }
      });
      document.addEventListener("openable-element:open", (event) => {
        if (this.controlledElement === event.target) {
          this.isExpanded = true;
          event.stopPropagation();
        }
      });
      this.rootDelegate.on(
        "openable-element:load:start",
        `#${this.getAttribute("aria-controls")}`,
        () => {
          if (this.classList.contains("button")) {
            this.setAttribute("aria-busy", "true");
          } else if (this.offsetParent !== null) {
            triggerEvent(document.documentElement, "theme:loading:start");
          }
        },
        true
      );
      this.rootDelegate.on(
        "openable-element:load:end",
        `#${this.getAttribute("aria-controls")}`,
        () => {
          if (this.classList.contains("button")) {
            this.removeAttribute("aria-busy");
          } else if (this.offsetParent !== null) {
            triggerEvent(document.documentElement, "theme:loading:end");
          }
        },
        true
      );
    }
    disconnectedCallback() {
      this.rootDelegate.destroy();
    }
    get isExpanded() {
      return this.getAttribute("aria-expanded") === "true";
    }
    set isExpanded(value) {
      this.setAttribute("aria-expanded", value ? "true" : "false");
    }
    get controlledElement() {
      return document.getElementById(this.getAttribute("aria-controls"));
    }
    attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case "aria-expanded":
          if (oldValue === "false" && newValue === "true") {
            this.controlledElement.open = true;
          } else if (oldValue === "true" && newValue === "false") {
            this.controlledElement.open = false;
          }
          break;
        case "aria-busy":
          if (this.hasAttribute("loader")) {
            if (newValue === "true") {
              this._startTransition();
            } else {
              this._endTransition();
            }
          }
          break;
      }
    }
  };
  Object.assign(ToggleButton.prototype, LoaderButtonMixin);
  defineCE("toggle-button", ToggleButton, { extends: "button" });

  // js/custom-element/behavior/toggle-link.js
  var ToggleLink = class extends HTMLAnchorElement {
    static get observedAttributes() {
      return ["aria-expanded"];
    }
    constructor() {
      super();
      this.addEventListener("click", (event) => {
        event.preventDefault();
        this.isExpanded = !this.isExpanded;
      });
      this.rootDelegate = new main_default(document.documentElement);
    }
    connectedCallback() {
      this.rootDelegate.on(
        "openable-element:close",
        `#${this.getAttribute("aria-controls")}`,
        (event) => {
          if (this.controlledElement === event.target) {
            this.isExpanded = false;
          }
        },
        true
      );
      this.rootDelegate.on(
        "openable-element:open",
        `#${this.getAttribute("aria-controls")}`,
        (event) => {
          if (this.controlledElement === event.target) {
            this.isExpanded = true;
          }
        },
        true
      );
    }
    disconnectedCallback() {
      this.rootDelegate.destroy();
    }
    get isExpanded() {
      return this.getAttribute("aria-expanded") === "true";
    }
    set isExpanded(value) {
      this.setAttribute("aria-expanded", value ? "true" : "false");
    }
    get controlledElement() {
      return document.querySelector(`#${this.getAttribute("aria-controls")}`);
    }
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === "aria-expanded") {
        if (oldValue === "false" && newValue === "true") {
          this.controlledElement.open = true;
        } else if (oldValue === "true" && newValue === "false") {
          this.controlledElement.open = false;
        }
      }
    }
  };
  defineCE("toggle-link", ToggleLink, { extends: "a" });

  // js/custom-element/ui/input-number.js
  // Customized built-in used by product quantity, cart line items, and ed-quantity-discounts.
  var InputNumber = class extends HTMLInputElement {
    constructor() {
      super();
      this._onInput = this._onInput.bind(this);
      this._onBlur = this._onBlur.bind(this);
    }
    connectedCallback() {
      if (this._inputNumberListeners) return;
      this._inputNumberListeners = true;
      this.addEventListener("input", this._onInput);
      this.addEventListener("blur", this._onBlur);
    }
    disconnectedCallback() {
      if (!this._inputNumberListeners) return;
      this._inputNumberListeners = false;
      this.removeEventListener("input", this._onInput);
      this.removeEventListener("blur", this._onBlur);
    }
    get quantity() {
      return parseInt(this.value, 10) || 0;
    }
    set quantity(value) {
      const min = this._readMin();
      const max = this._readMax();
      let v = parseInt(String(value), 10);
      if (isNaN(v) || v < min) v = min;
      if (v > max) v = max;
      if (this.value !== String(v)) {
        this.value = String(v);
        this.dispatchEvent(new Event("input", { bubbles: true }));
        this.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
    _readMin() {
      const m = parseInt(this.getAttribute("min"), 10);
      return isNaN(m) ? 1 : m;
    }
    _readMax() {
      const raw = this.getAttribute("max");
      if (raw === null || raw === "") return 999999;
      const m = parseInt(raw, 10);
      return isNaN(m) ? 999999 : m;
    }
    _onInput() {
      const digits = this.value.replace(/\D/g, "");
      if (digits !== this.value) this.value = digits;
    }
    _onBlur() {
      const min = this._readMin();
      const max = this._readMax();
      let v = parseInt(this.value, 10);
      if (isNaN(v)) v = min;
      v = Math.max(min, Math.min(max, v));
      if (this.value !== String(v)) {
        this.value = String(v);
        this.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  };
  defineCE("input-number", InputNumber, { extends: "input" });

  // js/custom-element/ui/quantity-selector.js
  // Wraps product-form +/- buttons and syncs the nested quantity input.
  var QuantitySelector = class extends HTMLElement {
    constructor() {
      super();
      this._onDecrease = this._onDecrease.bind(this);
      this._onIncrease = this._onIncrease.bind(this);
    }
    connectedCallback() {
      if (this._quantitySelectorBound) return;
      this._quantitySelectorBound = true;
      this.decreaseButton = this.querySelector(".quantity-selector__button-decrease");
      this.increaseButton = this.querySelector(".quantity-selector__button-increase");
      if (this.decreaseButton) this.decreaseButton.addEventListener("click", this._onDecrease);
      if (this.increaseButton) this.increaseButton.addEventListener("click", this._onIncrease);
    }
    disconnectedCallback() {
      if (!this._quantitySelectorBound) return;
      this._quantitySelectorBound = false;
      if (this.decreaseButton) this.decreaseButton.removeEventListener("click", this._onDecrease);
      if (this.increaseButton) this.increaseButton.removeEventListener("click", this._onIncrease);
    }
    _inputEl() {
      return this.querySelector(".quantity-selector__input");
    }
    _readMin(input) {
      const m = parseInt(input.getAttribute("min"), 10);
      return isNaN(m) ? 1 : m;
    }
    _readMax(input) {
      const raw = input.getAttribute("max");
      if (raw === null || raw === "") return null;
      const m = parseInt(raw, 10);
      return isNaN(m) ? null : m;
    }
    _setQty(input, next) {
      if (parseInt(input.value, 10) === next) return;
      input.value = String(next);
      const evtOpts = { bubbles: true };
      input.dispatchEvent(new Event("input", evtOpts));
      input.dispatchEvent(new Event("change", evtOpts));
    }
    _onDecrease() {
      const input = this._inputEl();
      if (!input) return;
      const min = this._readMin(input);
      const n = parseInt(input.value, 10);
      const current = isNaN(n) ? min : n;
      const next = Math.max(min, current - 1);
      this._setQty(input, next);
    }
    _onIncrease() {
      const input = this._inputEl();
      if (!input) return;
      const min = this._readMin(input);
      const max = this._readMax(input);
      const n = parseInt(input.value, 10);
      const current = isNaN(n) ? min : n;
      let next = current + 1;
      if (max !== null) next = Math.min(max, next);
      this._setQty(input, next);
    }
  };
  defineCE("quantity-selector", QuantitySelector);

  // js/custom-element/behavior/page-dots.js
  var PageDots = class extends CustomHTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll("button"));
      this.delegate.on("click", "button", (event, target) => {
        this._dispatchEvent(this.buttons.indexOf(target));
      });
      if (this.hasAttribute("animation-timer")) {
        this.delegate.on("animationend", (event) => {
          if (event.elapsedTime > 0) {
            this._dispatchEvent(
              (this.selectedIndex + 1 + this.buttons.length) % this.buttons.length
            );
          }
        });
      }
    }
    get selectedIndex() {
      return this.buttons.findIndex(
        (button) => button.getAttribute("aria-current") === "true"
      );
    }
    set selectedIndex(selectedIndex) {
      this.buttons.forEach((button, index) =>
        button.setAttribute(
          "aria-current",
          selectedIndex === index ? "true" : "false"
        )
      );
    }
    _dispatchEvent(index) {
      if (index !== this.selectedIndex) {
        this.dispatchEvent(
          new CustomEvent("page-dots:changed", {
            bubbles: true,
            detail: { index },
          })
        );
      }
    }
  };
  defineCE("page-dots", PageDots);

  // js/custom-element/behavior/prev-next-buttons.js
  var PrevNextButtons = class extends HTMLElement {
    connectedCallback() {
      this.prevButton = this.querySelector("button:first-of-type");
      this.nextButton = this.querySelector("button:last-of-type");
      this.prevButton.addEventListener("click", () =>
        this.prevButton.dispatchEvent(
          new CustomEvent("prev-next:prev", { bubbles: true })
        )
      );
      this.nextButton.addEventListener("click", () =>
        this.nextButton.dispatchEvent(
          new CustomEvent("prev-next:next", { bubbles: true })
        )
      );
    }
    set isPrevDisabled(value) {
      this.prevButton.disabled = value;
    }
    set isNextDisabled(value) {
      this.nextButton.disabled = value;
    }
  };
  var PrevButton = class extends HTMLButtonElement {
    connectedCallback() {
      this.addEventListener("click", () =>
        this.dispatchEvent(new CustomEvent("prev-next:prev", { bubbles: true }))
      );
    }
  };
  var NextButton = class extends HTMLButtonElement {
    connectedCallback() {
      this.addEventListener("click", () =>
        this.dispatchEvent(new CustomEvent("prev-next:next", { bubbles: true }))
      );
    }
  };
  defineCE("prev-next-buttons", PrevNextButtons);
  defineCE("prev-button", PrevButton, { extends: "button" });
  defineCE("next-button", NextButton, { extends: "button" });

  // js/custom-element/ui/product-list.js
  var ProductList = class extends CustomHTMLElement {
    connectedCallback() {
      this._prevNext = this.querySelector("prev-next-buttons");
      this._onScroll = this._updatePrevNextDisabled.bind(this);
      this._onResize = this._refreshScroller.bind(this);
      this._onPrevNextPrev = () => this._scrollBy(-1);
      this._onPrevNextNext = () => this._scrollBy(1);
      this._scrollListenerOptions = { passive: true };

      this.addEventListener("prev-next:prev", this._onPrevNextPrev);
      this.addEventListener("prev-next:next", this._onPrevNextNext);
      window.addEventListener("resize", this._onResize);

      if ("ResizeObserver" in window) {
        this._resizeObserver = new ResizeObserver(() => this._refreshScroller());
        this._resizeObserver.observe(this);
        const inner = this.querySelector(".product-list__inner--scroller");
        if (inner) this._resizeObserver.observe(inner);
      }

      this._hiddenObserver = new MutationObserver(() => {
        if (!this.hasAttribute("hidden")) {
          this._refreshScroller();
        }
      });
      this._hiddenObserver.observe(this, {
        attributes: true,
        attributeFilter: ["hidden"],
      });

      this._refreshScroller();
      this._prevNextReadyRetries = 0;
      queueMicrotask(() => this._updatePrevNextDisabled());
    }
    disconnectedCallback() {
      this.removeEventListener("prev-next:prev", this._onPrevNextPrev);
      this.removeEventListener("prev-next:next", this._onPrevNextNext);
      window.removeEventListener("resize", this._onResize);
      if (this._scroller) {
        this._scroller.removeEventListener(
          "scroll",
          this._onScroll,
          this._scrollListenerOptions
        );
      }
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
      if (this._hiddenObserver) {
        this._hiddenObserver.disconnect();
        this._hiddenObserver = null;
      }
      super.disconnectedCallback();
    }
    _resolveScroller() {
      const inner = this.querySelector(".product-list__inner--scroller");
      if (!inner) return null;
      const outer = inner.parentElement?.classList?.contains("scroller")
        ? inner.parentElement
        : null;
      if (outer && outer.scrollWidth > outer.clientWidth + 1) return outer;
      return inner;
    }
    _refreshScroller() {
      const nextScroller = this._resolveScroller();
      if (nextScroller !== this._scroller) {
        if (this._scroller) {
          this._scroller.removeEventListener(
            "scroll",
            this._onScroll,
            this._scrollListenerOptions
          );
        }
        this._scroller = nextScroller;
        if (this._scroller) {
          this._scroller.addEventListener(
            "scroll",
            this._onScroll,
            this._scrollListenerOptions
          );
        }
      }
      this._updatePrevNextDisabled();
    }
    _scrollBy(direction) {
      const el = this._scroller;
      if (!el) return;
      const distance = Math.max(1, Math.round(el.clientWidth * 0.85));
      const rtl = getComputedStyle(el).direction === "rtl";
      const sign = direction * (rtl ? -1 : 1);
      el.scrollBy({ left: sign * distance, behavior: "smooth" });
    }
    _updatePrevNextDisabled() {
      this._prevNext = this._prevNext || this.querySelector("prev-next-buttons");
      if (!this._prevNext) return;
      if (!this._prevNext.prevButton) {
        if (this._prevNextReadyRetries < 24) {
          this._prevNextReadyRetries += 1;
          queueMicrotask(() => this._updatePrevNextDisabled());
        }
        return;
      }
      this._prevNextReadyRetries = 0;
      const el = this._scroller;
      if (!el) {
        this._prevNext.isPrevDisabled = true;
        this._prevNext.isNextDisabled = true;
        return;
      }
      const max = el.scrollWidth - el.clientWidth;
      const tolerance = 3;
      if (max <= tolerance) {
        this._prevNext.isPrevDisabled = true;
        this._prevNext.isNextDisabled = true;
        return;
      }
      const rtl = getComputedStyle(el).direction === "rtl";
      const sl = el.scrollLeft;
      let atStart;
      let atEnd;
      if (rtl && sl < 0) {
        atStart = sl >= -tolerance;
        atEnd = sl <= -max + tolerance;
      } else {
        atStart = sl <= tolerance;
        atEnd = sl >= max - tolerance;
      }
      this._prevNext.isPrevDisabled = atStart;
      this._prevNext.isNextDisabled = atEnd;
    }
  };
  defineCE("product-list", ProductList);

  // js/custom-element/ui/popover.js
  var PopoverContent = class extends OpenableElement {
    connectedCallback() {
      super.connectedCallback();
      this.delegate.on("click", ".popover__overlay", () => (this.open = false));
    }
    attributeChangedCallback(name, oldValue, newValue) {
      super.attributeChangedCallback(name, oldValue, newValue);
      if (name === "open") {
        document.documentElement.classList.toggle("lock-mobile", this.open);
      }
    }
  };
  defineCE("popover-content", PopoverContent);

  // js/custom-element/ui/drawer.js
  var DrawerContent = class extends OpenableElement {
    connectedCallback() {
      super.connectedCallback();
      if (this.hasAttribute("reverse-breakpoint")) {
        this.originalDirection = this.classList.contains("drawer--from-left")
          ? "left"
          : "right";
        const match = window.matchMedia(this.getAttribute("reverse-breakpoint"));
        match.addListener(this._checkReverseOpeningDirection.bind(this));
        this._checkReverseOpeningDirection(match);
      }
      this.delegate.on("click", ".drawer__overlay", () => (this.open = false));
    }
    attributeChangedCallback(name, oldValue, newValue) {
      super.attributeChangedCallback(name, oldValue, newValue);
      if (name === "open") {
        document.documentElement.classList.toggle("lock-all", this.open);
      }
    }
    _checkReverseOpeningDirection(match) {
      this.classList.remove("drawer--from-left");
      if (
        (this.originalDirection === "left" && !match.matches) ||
        (this.originalDirection !== "left" && match.matches)
      ) {
        this.classList.add("drawer--from-left");
      }
    }
  };
  defineCE("drawer-content", DrawerContent);

  // js/custom-element/ui/product-image-zoom.js — PhotoSwipe lightbox for product (and featured product) media.
  const loadPhotoSwipeLib = (() => {
    let promise = null;
    return () => {
      if (window.ThemePhotoSwipe) return Promise.resolve(window.ThemePhotoSwipe);
      if (promise) return promise;
      const src = window.themeVariables?.libs?.photoswipe;
      if (!src) return Promise.reject(new Error("Missing themeVariables.libs.photoswipe"));
      promise = new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.src = src;
        s.async = true;
        s.onload = () => resolve(window.ThemePhotoSwipe);
        s.onerror = () => reject(new Error("Failed to load PhotoSwipe"));
        document.head.appendChild(s);
      });
      return promise;
    };
  })();

  var ProductImageZoom = class extends HTMLElement {
    constructor() {
      super();
      this._gallery = null;
      this._opening = false;
      this._onUiClick = this._onUiClick.bind(this);
    }
    get open() {
      return this.hasAttribute("open");
    }
    set open(value) {
      if (value) {
        void this._open();
      } else {
        this._closeFromProp();
      }
    }
    _closeFromProp() {
      if (this._gallery) {
        try {
          this._gallery.close();
        } catch (_) {}
      } else {
        this.removeAttribute("open");
      }
    }
    disconnectedCallback() {
      this._closeFromProp();
    }
    async _open() {
      if (this._gallery || this._opening) return;
      this._opening = true;
      try {
        const PhotoSwipe = await loadPhotoSwipeLib();
        if (!PhotoSwipe) {
          triggerEvent(this, "openable-element:close");
          return;
        }
        const items = this._collectItems();
        if (!items.length) {
          triggerEvent(this, "openable-element:close");
          return;
        }
        const index = this._initialIndex();
        this._gallery = new PhotoSwipe(this, null, items, {
          index,
          bgOpacity: 1,
          history: false,
          loop: false,
          focus: true,
          modal: true,
          closeOnScroll: false,
          showHideOpacity: true,
          showAnimationDuration: 333,
          hideAnimationDuration: 333,
        });
        this._gallery.listen("destroy", () => {
          this.removeEventListener("click", this._onUiClick);
          this._gallery = null;
          this.removeAttribute("open");
          triggerEvent(this, "openable-element:close");
        });
        this.addEventListener("click", this._onUiClick);
        this._gallery.init();
        this.setAttribute("open", "");
        triggerEvent(this, "openable-element:open");
      } catch (_) {
        triggerEvent(this, "openable-element:close");
      } finally {
        this._opening = false;
      }
    }
    _onUiClick(event) {
      if (!this._gallery) return;
      if (event.target.closest(".pswp__bg")) {
        event.preventDefault();
        this._gallery.close();
        return;
      }
      const control = event.target.closest("[data-action]");
      if (!control) return;
      const action = control.getAttribute("data-action");
      if (action === "pswp-close") {
        event.preventDefault();
        this._gallery.close();
      } else if (action === "pswp-prev") {
        event.preventDefault();
        this._gallery.prev();
      } else if (action === "pswp-next") {
        event.preventDefault();
        this._gallery.next();
      }
    }
    _productMediaRoot() {
      return this.closest("product-media");
    }
    _imageSlides() {
      const root = this._productMediaRoot();
      if (!root) return [];
      return Array.from(
        root.querySelectorAll('.product__media-item:not(.is-filtered)[data-media-type="image"]')
      );
    }
    _collectItems() {
      const items = [];
      for (const slide of this._imageSlides()) {
        const img = slide.querySelector(".product__media-image-wrapper img") || slide.querySelector("img");
        if (!img) continue;
        const src = img.currentSrc || img.src;
        if (!src) continue;
        let w = img.naturalWidth;
        let h = img.naturalHeight;
        if (!w || !h) {
          w = parseInt(img.getAttribute("width"), 10) || 1600;
          h = parseInt(img.getAttribute("height"), 10) || 1600;
        }
        items.push({ src, w, h });
      }
      return items;
    }
    _initialIndex() {
      const slides = this._imageSlides();
      const root = this._productMediaRoot();
      const carousel = root?.querySelector("flickity-carousel");
      const selected = carousel?.flickity?.selectedElement;
      if (!selected) return 0;
      const slideEl = selected.matches(".product__media-item")
        ? selected
        : selected.closest(".product__media-item");
      if (!slideEl) return 0;
      const idx = slides.indexOf(slideEl);
      return idx >= 0 ? idx : 0;
    }
  };
  defineCE("product-image-zoom", ProductImageZoom);

  function getThemeVars() {
    return window.themeVariables || {};
  }
  function emitCartRefresh(cart, detail = {}) {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: { cart, ...detail },
      })
    );
  }
  function emitCartUpdated(cart) {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
        detail: { cart },
      })
    );
  }
  function isFullCartShape(obj) {
    return obj && typeof obj === "object" && typeof obj.item_count === "number";
  }
  function resolveCartForUpdatedEvent(json, cartPayload) {
    if (isFullCartShape(cartPayload)) return cartPayload;
    if (isFullCartShape(json)) return json;
    if (json && Array.isArray(json.items)) {
      const item_count = json.items.reduce(
        (sum, li) => sum + (parseInt(li.quantity, 10) || 0),
        0
      );
      return { ...json, item_count };
    }
    return null;
  }
  function emitCartUpdatedFromAddResponse(json, cartPayload) {
    const resolved = resolveCartForUpdatedEvent(json, cartPayload);
    if (resolved) {
      emitCartUpdated(resolved);
    } else {
      getCartJson()
        .then((cart) => emitCartUpdated(cart))
        .catch(() => {});
    }
  }
  function emitVariantAdded(target, variant) {
    const eventTarget = target || document.documentElement;
    eventTarget.dispatchEvent(new CustomEvent("variant:added", { bubbles: true, detail: { variant } }));
  }
  async function getCartJson() {
    const tv = getThemeVars();
    const res = await fetch(`${tv.routes.cartUrl}.js`);
    return res.json();
  }
  async function addToCartFormData(formData, options = {}) {
    const tv = getThemeVars();
    const cartType = tv.settings?.cartType;
    const openMiniCart =
      typeof options.openMiniCart === "boolean" ? options.openMiniCart : cartType === "drawer";
    const replacementDelay =
      typeof options.replacementDelay === "number" ? options.replacementDelay : 0;
    const variantAddedTarget = options.variantAddedTarget || null;

    const res = await fetch(`${tv.routes.cartAddUrl}.js`, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData,
      credentials: "same-origin",
    });
    const json = await res.json();
    if (json?.status === 422) {
      throw new Error(json?.description || json?.message || "Add to cart failed");
    }

    let cartPayload = null;
    if (json?.sections?.["mini-cart"]) {
      cartPayload = json;
      emitCartRefresh(cartPayload, { openMiniCart, replacementDelay });
    } else {
      cartPayload = await getCartJson();
      emitCartRefresh(cartPayload, { openMiniCart });
    }

    emitCartUpdatedFromAddResponse(json, cartPayload);
    emitVariantAdded(variantAddedTarget, json?.items?.[0] || json);

    return { addResponse: json, cartPayload };
  }
  async function addToCartJson(body, options = {}) {
    const tv = getThemeVars();
    const cartType = tv.settings?.cartType;
    const openMiniCart =
      typeof options.openMiniCart === "boolean" ? options.openMiniCart : cartType === "drawer";
    const replacementDelay =
      typeof options.replacementDelay === "number" ? options.replacementDelay : 0;
    const variantAddedTarget = options.variantAddedTarget || null;

    const res = await fetch(`${tv.routes.cartAddUrl}.js`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify(body),
      credentials: "same-origin",
    });
    const json = await res.json();
    if (json?.status === 422 || !res.ok) {
      throw new Error(json?.description || json?.message || "Add to cart failed");
    }

    let cartPayload = null;
    if (json?.sections?.["mini-cart"]) {
      cartPayload = json;
      emitCartRefresh(cartPayload, { openMiniCart, replacementDelay });
    } else {
      cartPayload = await getCartJson();
      emitCartRefresh(cartPayload, { openMiniCart });
    }

    emitCartUpdatedFromAddResponse(json, cartPayload);
    emitVariantAdded(variantAddedTarget, json?.items?.[0] || json);

    return { addResponse: json, cartPayload };
  }
  async function addVariantToCart(variantId, quantity = 1, options = {}) {
    const formData = new FormData();
    formData.append("id", String(variantId));
    formData.append("quantity", String(quantity));
    formData.append("sections", "mini-cart");
    formData.append("sections_url", window.location.pathname);
    return addToCartFormData(formData, options);
  }
  async function addItemsToCart(items, options = {}) {
    return addToCartJson(
      {
        items,
        sections: "mini-cart",
        sections_url: window.location.pathname,
      },
      options
    );
  }

  // Product cards use `is="product-form"`, but `theme-product.js` only loads on product pages,
  // so those forms never upgrade and would do a full-page POST. Mirror ProductForm AJAX here.
  document.addEventListener(
    "submit",
    async (event) => {
      const form = event.target;
      if (
        !(form instanceof HTMLFormElement) ||
        (form.getAttribute("is") !== "product-form" &&
          !form.classList.contains("product-item__cta-form") &&
          !form.classList.contains("product-item__quick-form"))
      ) {
        return;
      }
      if (event.defaultPrevented) return;

      const tv = getThemeVars();
      if (!tv?.routes?.cartAddUrl) return;

      const cartType = tv.settings?.cartType;
      if (tv.settings?.pageType === "cart" || cartType === "page") return;

      event.preventDefault();

      const submitButton =
        (event.submitter && event.submitter.matches?.("button[type='submit']")
          ? event.submitter
          : null) ||
        form.querySelector("[data-product-add-to-cart-button]") ||
        form.querySelector('button[type="submit"]');

      const setBusy = (button, busy) => {
        if (!button) return;
        if (busy) {
          button.setAttribute("aria-busy", "true");
          button.disabled = true;
        } else {
          button.removeAttribute("aria-busy");
          button.disabled = false;
        }
      };

      const animateSuccess = (button) => {
        if (!button) return;
        const textEl = button.querySelector(".loader-button__text") || button;
        const previous = textEl.innerHTML;
        const addedLabel =
          tv.strings?.cartItemAddedShort || tv.strings?.cartItemAdded || "Added";
        textEl.innerHTML = addedLabel;
        try {
          button.animate(
            [
              { transform: "scale(1)" },
              { transform: "scale(1.03)" },
              { transform: "scale(1)" },
            ],
            { duration: 420, easing: "cubic-bezier(0.2, 0.9, 0.2, 1)" }
          );
        } catch (_) {}
        window.setTimeout(() => {
          if (textEl.innerHTML === addedLabel) textEl.innerHTML = previous;
        }, 1200);
      };

      setBusy(submitButton, true);

      try {
        const formData = new FormData(form);
        const variantField =
          form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
        const variantId = String(variantField?.value || "").trim();
        if (!formData.get("id") && variantId) formData.set("id", variantId);
        if (!formData.get("quantity")) formData.set("quantity", "1");

        formData.append("sections", "mini-cart");
        formData.append("sections_url", window.location.pathname);
        await addToCartFormData(formData, {
          openMiniCart: cartType === "drawer",
          replacementDelay: 0,
          variantAddedTarget: form,
        });
        animateSuccess(submitButton);

        if (cartType === "drawer") {
          const drawer = document.getElementById("mini-cart");
          if (drawer && "open" in drawer) drawer.open = true;
        }
      } catch (e) {
        console.error(e);
      } finally {
        setBusy(submitButton, false);
      }
    },
    false
  );

  window.ThemeCore = {
    Delegate: main_default,
    triggerEvent,
    triggerNonBubblingEvent,
    CustomHTMLElement,
    OpenableElement,
    CollapsibleContent,
    DrawerContent,
    PopoverContent,
    createFocusTrap,
    ATC: {
      addToCartFormData,
      addToCartJson,
      addVariantToCart,
      addItemsToCart,
    },
  };
})();